import { gte, equal } from 'junctions-fp'

/**
 * définit la taille de l'image par rapport au canvas.
 * Si la largeur ou la hauteur est inférieur  à la taille du canvas on les modifie
 * @param {number} w largeur de l'image
 * @param {number} h hauteur de l'image
 * @param {number} mw largeur du canvas
 * @param {number} mh hauteur du canvas
 */
const getSize = (w, h, mw = -1, mh = -1) => {
  let width = w
  let height = w
  let orientation = 'landscape'
  let ratio = 1
  if (gte(w)(h)) {
    orientation = 'portrait'
    ratio = h / w
  } else {
    ratio = w / h
  }
  if (equal(orientation)('landscape')) {
    width = mw
    height = Math.abs(width / ratio)
  } else {
    height = mh
    width = Math.abs(height / ratio)
  }
  return {
    width,
    height
  }
}

const calculateAspectRatioFit = (srcWidth, srcHeight, maxWidth, maxHeight) => {
  var ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight)
  return { width: srcWidth * ratio, height: srcHeight * ratio }
}

export { getSize, calculateAspectRatioFit }



// WEBPACK FOOTER //
// ./src/model/pixel/tools/ImageSize.js